<div class="key-warning-component-content">
	<div class="headline-container">
		<div class="headline">{{ "KEY_WARNING__TITLE" | transloco }}</div>
		<div class="message">{{ "KEY_WARNING__MESSAGE" | transloco }}</div>
	</div>

	<div class="setup-container">
		<ion-item>
			<ion-input
				[(ngModel)]="rideOpsKey"
				label="{{ 'SETUP_PAGE__RIDEOPS_KEY_INPUT_LABEL' | transloco }}"
				labelPlacement="stacked"
				[disabled]="testing"
				placeholder="xxxx-xxxx-xxxx-xxxx"
			></ion-input>
		</ion-item>
		<ion-button
			class="setup-button"
			expand="block"
			(click)="enter()"
			[disabled]="rideOpsKey == null || rideOpsKey.length <= 0 || testing"
		>
			{{ "KEY_WARNING__CHANGE" | transloco }}
		</ion-button>
	</div>

	<div class="error-description">
		@switch (keyTestResult) {
			@case ("NO_ACCESS_FOR_LOCATION") {
				<ion-text color="danger">{{ "KEY_WARNING__ERROR_TEXT__NO_ACCESS_FOR_LOCATION" | transloco }}</ion-text>
			}
			@case ("UNKNOWN") {
				<ion-text color="danger">
					{{ "KEY_WARNING__ERROR_TEXT__UNKNOWN" | transloco }}
				</ion-text>
			}
			@case ("KEY_INVALID") {
				<ion-text color="danger">
					{{ "KEY_WARNING__ERROR_TEXT__KEY_INVALID" | transloco }}
				</ion-text>
			}
			@default {}
		}
	</div>
</div>
